import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from '../../styles/printFont/vfs_fonts2';
import helper from "actions/helper";

//Вывести логотип влево вверху 
/*function getBase64ImageFromURL(url) {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.setAttribute("crossOrigin", "anonymous");

        img.onload = () => {
            let canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;

            let ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);

            let dataURL = canvas.toDataURL("image/png");

            resolve(dataURL);
        };

        img.onerror = error => {
            reject(error);
        };

        img.src = url;
    });
}*/

const Print = async (infoPrint) => {
    const { vfs } = pdfFonts.pdfMake;
    pdfMake.vfs = vfs;

    pdfMake.fonts = {
        Roboto: {
            normal: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
            bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
            italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
            bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
        },
    };

    const getRow = (i, data, isDiscount) => {
        const { title, price, count, sum, discount, sumDiscount, teeths } = data;
        const row = [
            { text: i + 1 + "", alignment: 'center' },
            { text: title },
            { text: teeths, alignment: 'center' },
            { text: count, alignment: 'center' },
            { text: price, alignment: 'center' },
        ];

        if (isDiscount) {
            row.push({ text: sum, alignment: 'center' });
            row.push({ text: discount, alignment: 'center' });
            row.push({ text: sumDiscount, alignment: 'center' });
        } else {
            row.push({ text: sum, alignment: 'center' });
        }

        return row;
    };

    const getRows = (it, isDiscount) => {
        let body = [[
            { text: "№", fillColor: '#B6DCFA', bold: true },
            { text: "Наименование позиции", alignment: 'center', fillColor: '#B6DCFA', bold: true },
            { text: "Зубы", alignment: 'center', fillColor: '#B6DCFA', bold: true },
            { text: "Кол-во", alignment: 'center', fillColor: '#B6DCFA', bold: true },
            { text: "Цена", alignment: 'center', fillColor: '#B6DCFA', bold: true },
        ]];

        if (isDiscount) {
            body[0].push({ text: "Стоимость", alignment: 'center', fillColor: '#B6DCFA', bold: true });
            body[0].push({ text: "Скидка", alignment: 'center', fillColor: '#B6DCFA', bold: true });
            body[0].push({ text: "Сумма со скидкой", alignment: 'center', fillColor: '#B6DCFA', bold: true });
        } else {
            body[0].push({ text: "Стоимость", alignment: 'center', fillColor: '#B6DCFA', bold: true });
        }

        const defaultSize = {
            pricecount: 50,
            price: 25,
            amount: 30,
            teeths: 25,
            sumDiscount: 30
        };

        it.securedInvoiceItems.sort((a, b) => a.sortIndex - b.sortIndex).forEach((inv, i) => {
            const { altCode, title, price, count, discount, teeth } = inv;
            const data = {
                title: `${altCode} ${title}`,
                teeths: helper.getTeethNames(teeth).join(", "),
                count: count + "",
                price: helper.number.toSum(price),
                sum: helper.number.toSum(price * count),
            };

            if (isDiscount) {
                data.discount = ((discount && discount.toFixed(2)) || 0) + "%";
                data.sumDiscount = `${helper.number.toSum(helper.number.percentMinus(price * count, discount))}`;
            }

            body = [...body, getRow(i, data, isDiscount)];

            if (data.price.length === 7)
                defaultSize.price = 40;
            else if (data.price.length === 8)
                defaultSize.price = 45;
            else if (data.price.length === 9)
                defaultSize.price = 50;
            else if (data.price.length > 9)
                defaultSize.price = 55;

            if (isDiscount) {
                if (data.sumDiscount.length === 7)
                    defaultSize.sumDiscount = 40;
                else if (data.sumDiscount.length === 8)
                    defaultSize.sumDiscount = 45;
                else if (data.sumDiscount.length === 8)
                    defaultSize.sumDiscount = 50;
                else if (data.sumDiscount.length > 8)
                    defaultSize.sumDiscount = 55;
            }

            if (data.teeths.length > 14)
                defaultSize.teeths = 70;
            else if (data.teeths.length > 11)
                defaultSize.teeths = 55;
            else if (data.teeths.length > 8)
                defaultSize.teeths = 50;
            else if (data.teeths.length > 6)
                defaultSize.teeths = 40;
        });

        const { pricecount, price, amount, teeths, sumDiscount } = defaultSize;

        const widths = isDiscount ? [15, '*', teeths, amount, price, pricecount, 35, sumDiscount] : [15, '*', teeths, amount, price, pricecount];

        return { widths, body };
    };

    const formPage = (it, property) => {
        const isDiscount = it.securedInvoiceItems.some(inv => inv.discount);
        const page = [
            {
                style: 'header2',
                text: [
                    {
                        text: "Акт сдачи-приёмки оказанных платных медицинских услуг от: ", bold: true,
                    },
                    ` ${helper.date.toStr(new Date(it.createdTime), "DD.MM.YYYY")}`
                ]
            },
            {
                style: 'doctor',
                text: [
                    "Исполнитель: ",
                    "",
                ]
            },
            {
                style: 'client',
                text: [
                    "Пациент: ",
                    { text: `${it.fio}`, bold: true, },
                ]
            },

            {
                style: 'doctor',
                text: [
                    "Дата рождения: ",
                    { text: it.birthday ? helper.date.toStr(it.birthday, "DD.MM.YYYY") : "", bold: true },
                ]
            },
            {
                /*unbreakable: true,*/
                style: 'table',
                table: getRows(it, isDiscount)
            },
            {
                style: 'itogo',
                text: ["Итого: ", { text: helper.number.toSum(it.totalSum) }]
            },
        ];

        return page;
    };

    const getProperty = () => {
        const { clinic } = infoPrint;
        const { organisationName, address, license, phone, city } = clinic;
        const lic = license.split(' от ')[0];
        const add = city.name + " " + address;
        const ph = "Тел: " + helper.inputValidators.phone(phone);

        return { organisationName, lic, add, ph };
    };

    const property = getProperty();

    const documentDefinition = {
        pageSize: 'A4',
        content: [
            /*{
                image: await getBase64ImageFromURL("/img/br_header-for-A4.png"),
                width: 515,
                rowSpan: 2,
                margin: [0, -20, 0, 0]
            },*/
            {
                style: 'header',
                table: {

                    widths: ['*', 150],
                    body: [
                        [
                            "",
                            "Приложение"
                        ],
                        [
                            "",
                            "к Договору об оказании"
                        ],
                        [
                            "",
                            "платных медицинских услуг"
                        ],
                        [
                            "",
                            `№ ${infoPrint.profileNumber} от ${helper.date.toStr(infoPrint.dateRegistration, "DD.MM.YYYY")}`
                        ],
                    ],
                },
                layout: 'noBorders'
            },
            ...formPage(infoPrint, property),
            {
                unbreakable: true,
                style: 'itogoTable2',
                table: {
                    dontBreakRows: true,
                    widths: ['*'],
                    body: [
                        [
                            `Пациент и исполнитель составили настоящий акт о том, что все вышеперечисленные услуги выполнены в соответствии с условиями настоящего договора, полностью и в срок.`
                        ],
                        [
                            `Пациент не имеет претензий по объему, качеству, эстетическим свойствам и срокам оказания услуг, результатом оказания услуг полностью удовлетворен.`,
                        ]
                    ],
                },
                layout: {
                    hLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.body.length) ? 1 : 0;
                    },
                    vLineWidth: function (i, node) {
                        return (i === 0 || i === node.table.widths.length) ? 1 : 0;
                    },
                    hLineStyle: function (i, node) {
                        return { dash: { length: 3, space: 2 } };
                    },
                    vLineStyle: function (i, node) {
                        return { dash: { length: 3, space: 2 } };
                    },
                    paddingLeft: function (i, node) { return 5; },
                    paddingRight: function (i, node) { return 5; },
                    paddingTop: function (i, node) { return 5; },
                    paddingBottom: function (i, node) { return 5; },
                }
            },
            {
                style: 'signTable',
                table: {

                    widths: ['*', 260],
                    body: [
                        [
                            { text: "Исполнитель:", bold: true },
                            { text: "Пациент:", bold: true },
                        ],
                        [
                            "__________________________________________",
                            "__________________________________________",
                        ],
                        [
                            "Администратор клиники",
                            "ФИО, Подпись",
                        ],
                        [
                            "",
                            { text: "Законный представитель:", bold: true },
                        ],
                        [
                            "",
                            "__________________________________________",
                        ],
                        [
                            "",
                            "ФИО, Подпись",
                        ],

                    ],
                },
                layout: 'noBorders'
            },

        ],
        styles: {
            header: {
                fontSize: 9,
                lineHeight: 0.7,
                margin: [0, 10, 0, 20]
            },
            header2: {
                fontSize: 12,
                alignment: 'center',
                margin: [0, 0, 0, 15]
            },
            client: {
                margin: [0, 0, 0, 10]
            },
            doctor: {
                margin: [0, 0, 0, 15]
            },
            table: {
                fontSize: 9,
            },
            itogo: {
                fontSize: 12,
                margin: [0, 15, 0, 15]
            },
            itogoTable: {
            },
            itogoTable2: {
            },
            signTable: {
                margin: [0, 20, 0, 0]
            },
        },
        defaultStyle: {
            fontSize: 10,
        }
    };

    pdfMake.createPdf(documentDefinition).open();

};

export default Print;
